import { createFeatureSelector, createSelector } from '@ngrx/store';
import { OffersState } from '../reducers/base-offers.reducer';
import { CustomerOfferListItemResponse, CustomerOfferResponse, FiltersResponse, MetaPagination } from '../../../api';

const getOffersRoot = createFeatureSelector('offers');

const getOffersState = createSelector(getOffersRoot, (state: any): OffersState => state);

export const getOffersList = createSelector(
  getOffersState,
  (
    state: OffersState
  ): {
    data: CustomerOfferListItemResponse[] | undefined;
    pagination: MetaPagination | undefined;
    filters: FiltersResponse | undefined;
    ok: boolean | undefined;
  } => state.offersList
);

export const getOfferDetails = createSelector(
  getOffersState,
  (
    state: OffersState
  ): {
    data: CustomerOfferResponse | undefined;
    ok: boolean | undefined;
  } => state.offerDetails
);

export const getDownloadedFile = createSelector(
  getOffersState,
  (state: OffersState): { data: Blob | undefined } => state.downloadOfferedDaysFile
);
